import { createFileRoute } from "@tanstack/react-router";
import { DeskPage } from "../../../components/desk/desk-page";
import { deskSearch } from "../../../lib/desk/search";

/** Awarded events, newest release first (`GET /medals/events?state=AWARDED&sort=recent`) — open one to review, correct or confirm it. */
export const Route = createFileRoute("/_app/award/awarded")({
	validateSearch: deskSearch,
	component: function AwardedDesk() {
		const search = Route.useSearch();
		return <DeskPage list="awarded" search={search} />;
	},
});
